var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplore1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 376,
    viewBox: "0 0 358 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.374 187.638L327.507 196.518",
    stroke: "#3A7CC3",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.362 197.621L336.652 213.51",
    stroke: "#0251C7",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.306 208.521L337.659 230.208",
    stroke: "#3A7CC3",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.728 221.312L337.133 245.204",
    stroke: "#DD1133",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.035 243.044L308.936 250.522",
    stroke: "#DD1133",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M265.647 252.098L316.578 268.024",
    stroke: "#3A7CC3",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248.393 261.679L325.826 285.893",
    stroke: "#3A7CC3",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.288 277.403L315.842 297.902",
    stroke: "#019BA5",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M264.152 296.367L294.158 305.751",
    stroke: "#3A7CC3",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236.634 302.514L313.79 326.642",
    stroke: "#3A7CC3",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.598 326.127L277.045 329.707",
    stroke: "#3A7CC3",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.778 334.713L287.297 347.07",
    stroke: "#DD1133",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M237.013 345.946L290.257 362.596",
    stroke: "#DD1133",
    strokeWidth: 7.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore1);
export default __webpack_public_path__ + "static/media/explore1.f2270824d47881695b599e8963caeaca.svg";
export { ForwardRef as ReactComponent };